__turbopack_context__.v({
  "className": "poppins_fc57481a-module__p5QZLa__className",
  "variable": "poppins_fc57481a-module__p5QZLa__variable",
});
